<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Stok Durumları</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="info" @click="SayfaYukle" :disabled="lo">yenile</el-button>
      </div>
    </div>
    <div class="SayfaIcerik SayfaTable" v-loading="lo">
      <el-table
          v-if="Liste"
          class="table-xs table-hover"
          :data="Liste.filter(data => !Kelime || data.adi.toLowerCase().includes(Kelime.toLowerCase()))"

          :height="Height">
        <el-table-column label="#" prop="id" width="75"></el-table-column>
        <el-table-column label="Ürün Adı" prop="adi"></el-table-column>
        <el-table-column label="Adet" prop="sadet"></el-table-column>
        <el-table-column
            align="right" label="Bolge" prop="Grup" width="250" class-name="tablearama">
          <template slot="header" slot-scope="scope">
            <el-input
                v-model="Kelime"
                size="mini"
                class="tablearamainput"
                placeholder="Arama Yapın"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>


export default {

  data() {
    return {
      lo: false,
      ModalDurum: false,
      Tur: null,
      Kelime: "",
      Height: null,
      Bilgi: null,
      Liste: null
    }
  },
  methods: {
    TableSecim(e) {
      //this.$router.push('/bolge/' + e.id)
      //this.Bilgi
    },
    SayfaYukle() {
      this.lo = true
      this.ModalDurum = false
      this.$store.dispatch("Get", {path: 'urun'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Liste = response.Data
              this.lo = false
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    },
    handleEdit(index, row) {
      this.Tur = 'Put'
      this.Bilgi = row
      this.ModalDurum = true
      this.$forceUpdate()

    },
    handleDelete(index, row) {
      this.$store.dispatch("Delete", {path: 'bolge/' + row.id})
          .then(response => {
            if (response.Durum === "OK") {
              this.$notify.info({
                title: response.Mesaj,
                customClass: 'info'
              });
              this.DetayModalDurum = false
              this.SayfaYukle()
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    },
    BolgeEkle() {
      this.ModalDurum = true
      this.Bilgi = {};
      this.Tur = 'Post'

    }
  },
  created() {
    this.$store.dispatch("title", "Bölge İşlemleri");
    this.SayfaYukle();
    this.Height = window.innerHeight - 111
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/stok.vue